import { render, staticRenderFns } from "./specialty_chart.vue?vue&type=template&id=4c88202c&"
import script from "./specialty_chart.vue?vue&type=script&lang=js&"
export * from "./specialty_chart.vue?vue&type=script&lang=js&"
import style0 from "./specialty_chart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports